import { render, staticRenderFns } from "./BindStaff.vue?vue&type=template&id=546fc104&"
import script from "./BindStaff.vue?vue&type=script&lang=js&"
export * from "./BindStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports